{% block acris_blog_author_list %}
    <sw-page class="acris-blog-author-list">
        {% block acris_blog_author_list_search_bar %}
            <template #search-bar>
                <sw-search-bar initialSearchType="acris_blog_author"
                               :placeholder="$tc('acris-blog-author.general.placeholderSearchBar')"
                               :initialSearch="term"
                               @search="onSearch">
                </sw-search-bar>
            </template>
        {% endblock %}

        {% block acris_blog_author_list_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_blog_author_list_smart_bar_header_title %}
                    <h2>
                        {% block acris_blog_author_list_smart_bar_header_title_text %}
                            {{ $tc('acris-blog-author.list.textHeadline') }}
                        {% endblock %}

                        {% block acris_blog_author_list_smart_bar_header_amount %}
                            <span v-if="!isLoading" class="sw-page__smart-bar-amount">
                        ({{ total }})
                        </span>
                        {% endblock %}
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_author_list_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_blog_author_list_smart_bar_actions_add %}
                    <mt-button variant="primary" @click="$router.push({ name: 'acris.blog.author.create' })" size="default">
                        {{ $tc('acris-blog-author.list.buttonAdd') }}
                    </mt-button>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_author_list_cardview %}
            <template #content>
                <div class="acris-blog-author-list__content">
                    {% block acris_blog_author_list_content %}
                        <sw-entity-listing class="acris-blog-author-list-grid"
                                           v-if="items && total > 0"
                                           :items="items"
                                           :repository="entityRepository"
                                           detailRoute="acris.blog.author.detail"
                                           :showSeleciton="true"
                                           :isLoading="isLoading"
                                           :columns="columns">

                            <template #pagination>
                                {% block sw_order_list_grid_pagination %}
                                    <sw-pagination :page="page"
                                                   :limit="limit"
                                                   :total="total"
                                                   :total-visible="7"
                                                   @page-change="onPageChange">
                                    </sw-pagination>
                                {% endblock %}
                            </template>

                        </sw-entity-listing>
                    {% endblock %}

                    {% block acris_blog_author_list_empty_state %}
                        <sw-empty-state v-if="!isLoading && total === 0" :title="$tc('acris-blog-author.list.contentEmpty')" :show-description="false"></sw-empty-state>
                    {% endblock %}

                </div>
            </template>
        {% endblock %}

        {% block acris_blog_author_list_sidebar %}
            <template #sidebar>
                <sw-sidebar class="acris-blog-author-list__sidebar">
                    {% block acris_blog_author_list_sidebar_item %}
                        <sw-sidebar-item
                                icon="regular-undo"
                                :title="$tc('acris-blog-author.list.titleSidebarItemRefresh')"
                                @click="onRefresh">
                        </sw-sidebar-item>
                    {% endblock %}
                </sw-sidebar>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
